import { render, staticRenderFns } from "./entry-approval.vue?vue&type=template&id=5753f87c&scoped=true"
import script from "./entry-approval.vue?vue&type=script&lang=js"
export * from "./entry-approval.vue?vue&type=script&lang=js"
import style0 from "./entry-approval.vue?vue&type=style&index=0&id=5753f87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753f87c",
  null
  
)

export default component.exports